const STORAGE_KEY = "cookie-consent";
const OPEN_EVENT = "cookie-consent:open";

export function initConsent() {
    window.dataLayer = window.dataLayer || [];

    window.gtag = function () {
        window.dataLayer.push(arguments);
    };

    const consent = localStorage.getItem(STORAGE_KEY);

    window.gtag("consent", "default", {
        analytics_storage: consent === "accepted" ? "granted" : "denied",
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        wait_for_update: 500
    });
}

export function updateConsent(granted) {
    localStorage.setItem(STORAGE_KEY, granted ? "accepted" : "rejected");

    window.gtag("consent", "update", {
        analytics_storage: granted ? "granted" : "denied",
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied"
    });

    if (!granted) {
        removeAnalyticsCookies();
    }
}

//Al ritiro del consenso elimino i cookie di Google Analytics già impostati (_ga, _ga_<ID>)
function removeAnalyticsCookies() {
    const parts = window.location.hostname.split(".");
    const domains = [""];
    for (let i = 0; i < parts.length - 1; i++) {
        domains.push("; domain=." + parts.slice(i).join("."));
    }

    document.cookie.split(";").forEach((cookie) => {
        const name = cookie.split("=")[0].trim();
        if (name === "_ga" || name.startsWith("_ga_") || name === "_gid") {
            domains.forEach((domain) => {
                document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/" + domain;
            });
        }
    });
}

//Riapre il banner per permettere di modificare la scelta (link "Cookie settings")
export function openConsentBanner() {
    window.dispatchEvent(new Event(OPEN_EVENT));
}

export function onConsentBannerOpen(callback) {
    window.addEventListener(OPEN_EVENT, callback);
    return () => window.removeEventListener(OPEN_EVENT, callback);
}

export function hasConsent() {
    return localStorage.getItem(STORAGE_KEY);
}